import React, { Fragment, useState } from "react";
import { Row, Table, Badge, Button, Input } from "reactstrap";
import { Colxx } from "../../../components/common/CustomBootstrap";
import TooltipItem from "../../../components/common/TooltipItem";
import IntlMessages from "../../../helpers/IntlMessages";
import { AddCommaNumber, SetItemsSelected } from "../../../helpers/Utils";
import { injectIntl } from "react-intl";
import UpsellInline from "../../../containers/dashboards/UpsellInline";
import SuggestionPanel from "../../../containers/dashboards/SuggestionPanel";
import {
  getFeeApplicationBase,
  getPostDiscountSubtotal,
} from "../../../helpers/OrderAdjustmentCalculations";
import { getFeeOtherLabel } from "../../../helpers/FeeOtherLabel";

const formatOptionLabel = ({ label, icon }) => (
  <div className="d-flex align-items-center">
    {icon && <i className={`${icon} mr-2`} style={{ fontSize: "18px" }} />}
    <span>{label}</span>
  </div>
);

const ListOrders = ({
  orders,
  onHandlerDeleteOrderPending,
  incrementItem,
  decrementItem,
  onChangeCount,
  cashs,
  cashsPay,
  cashFill,
  totalPay,
  decrementCount,
  totalCustomerPay,
  discount_form,
  removeOrders,
  // onRemoveOrder,
  onCheckItemPending,
  handleSaveOrdersProvisionInvoice,
  getDiscountOrderNote,
  // getDiscountOrderType,
  // getDiscountOrderValue,
  getTotalDiscountPrice,
  calTotalPrice,
  handleToggleModalDiscountTaxFee,
  // handleToggleModalDiscount,
  tax_fee,
  // handleToggleModalTaxFee,
  getTotalTaxFeePrice,
  fee_other,
  // handleToggleModalFeeOther,
  getTotalFeeOtherPrice,
  isChecked,
  onHandleChecked,
  handleRemoveValueModal,
  itemsChange,
  promotion_result, // Kết quả tính toán khuyến mại
  paymentMethod,
  onChangePaymentMethod,
  shippingCarrier,
  isCustomPay = false,
  customCustomerPay = 0,
  customCustomerPayRaw = "",
  onChangeCustomerPay = () => {},
  onChangeShippingCarrier,
  staffList,
  selectedStaff,
  onChangeStaff,
  isCashierAccount, // True if user is a cashier (child account)
  connected_providers = [],
  shipping_fee = 0,
  is_calculating_fee = false,
  eInvoiceEnabled = false,
  issueEInvoice = false,
  onChangeIssueEInvoice,
  onOpenEInvoiceInfoModal,
  onUpgradeSize,
  onAddTopping,
  suggestionData,
  onAddSuggestionProduct,
  intl,
}) => {
  const { messages } = intl;
  const hasFeeOther = Boolean(
    fee_other && fee_other.saved && fee_other.value,
  );
  const feeOtherLabel = getFeeOtherLabel(messages, fee_other);

  const [editingIdx, setEditingIdx] = useState(null);
  const [tempCount, setTempCount] = useState("");

  const handleStartEdit = (idx, order) => {
    setEditingIdx(idx);
    setTempCount(order.count.toString());
  };

  const handleSaveCount = (order) => {
    const newCount = parseInt(tempCount, 10);
    if (!isNaN(newCount) && newCount >= 1) {
      if (onChangeCount) {
        onChangeCount(order, newCount);
      }
    }
    setEditingIdx(null);
  };

  const PAYMENT_METHOD_OPTIONS = [
    {
      value: "cash",
      label: messages["home.option.payment.cash"],
      icon: "simple-icon-wallet",
    },
    {
      value: "transfer",
      label: messages["home.option.payment.transfer"],
      icon: "iconsminds-bank",
    },
    {
      value: "card",
      label: messages["home.option.payment.card"],
      icon: "simple-icon-credit-card",
    },
    {
      value: "credit",
      label: messages["home.option.payment.credit"],
      icon: "simple-icon-notebook",
    },
  ];

  const SHIPPING_CARRIER_OPTIONS = [
    {
      value: "ghn",
      label: messages["home.shipping.ghn"],
      icon: "iconsminds-scooter",
    },
    {
      value: "ghtk",
      label: messages["home.shipping.ghtk"],
      icon: "iconsminds-box-close",
    },
    {
      value: "viettelpost",
      label: messages["home.shipping.viettelpost"],
      icon: "iconsminds-post-mail",
    },
    {
      value: "vnpost",
      label: messages["home.shipping.vnpost"],
      icon: "iconsminds-post-mail",
    },
    {
      value: "ahamove",
      label: messages["home.shipping.ahamove"],
      icon: "iconsminds-scooter",
    },
    {
      value: "lalamove",
      label: messages["home.shipping.lalamove"],
      icon: "iconsminds-scooter",
    },
    {
      value: "grabexpress",
      label: messages["home.shipping.grabexpress"],
      icon: "iconsminds-motorcycle",
    },
    {
      value: "shopeexpress",
      label: messages["home.shipping.shopeexpress"],
      icon: "iconsminds-scooter",
    },
    {
      value: "jtexpress",
      label: messages["home.shipping.jtexpress"],
      icon: "iconsminds-scooter",
    },
    {
      value: "ninjavan",
      label: messages["home.shipping.ninjavan"],
      icon: "iconsminds-scooter",
    },
    {
      value: "bestexpress",
      label: messages["home.shipping.bestexpress"],
      icon: "iconsminds-scooter",
    },
    {
      value: "kerryexpress",
      label: messages["home.shipping.kerryexpress"],
      icon: "iconsminds-scooter",
    },
    {
      value: "giaohangtietkiem",
      label: messages["home.shipping.ghtk"],
      icon: "iconsminds-box-close",
    },
  ];

  const orderSubtotal = calTotalPrice(orders);
  let total_discount_price = getTotalDiscountPrice(orders, discount_form);
  const adjustmentPercentageBase = getPostDiscountSubtotal(
    orderSubtotal,
    total_discount_price,
  );
  // let total_discount_price = promotion_result && promotion_result.totalDiscount;
  let total_taxfee_price = getTotalTaxFeePrice(
    orders,
    tax_fee,
    adjustmentPercentageBase,
  );
  const total_taxfee_payable =
    tax_fee && tax_fee.calculation === "included" ? 0 : total_taxfee_price;
  const feePercentageBase = getFeeApplicationBase(
    orderSubtotal,
    adjustmentPercentageBase,
    fee_other && fee_other.applyOn,
  );
  let total_fee_other_price = getTotalFeeOtherPrice(
    orders,
    fee_other,
    feePercentageBase,
  );
  const totalPayment =
    orderSubtotal -
    total_discount_price +
    (total_taxfee_payable || 0) +
    (total_fee_other_price ? total_fee_other_price : 0) +
    (shipping_fee ? shipping_fee : 0);

  let find_item_discount = orders.find(
    (order) => order.discount && order.discount.value,
  );

  const customerPayTotal = totalCustomerPay ? totalCustomerPay(cashsPay) : 0;
  const netRefundDifference =
    total_discount_price > 0 ||
    total_taxfee_price > 0 ||
    total_fee_other_price > 0
      ? customerPayTotal -
        orderSubtotal +
        total_discount_price -
        total_taxfee_payable -
        total_fee_other_price
      : customerPayTotal - orderSubtotal;

  const isMissingAmount = netRefundDifference < 0;
  const refundToCustomer = AddCommaNumber(Math.abs(netRefundDifference));

  const [missingAmountTooltip] = useState({
    placement: "top",
    text: "",
    body: messages["home.tooltip.missing-amount"],
  });

  const [donePayTooltip] = useState({
    placement: "left",
    text: "",
    body: messages["home.tooltip.done-pay"],
  });

  const [discountTooltip] = useState({
    placement: "top",
    text: "",
    body: messages["home.tooltip.discount"],
  });

  const [taxFeeTooltip] = useState({
    placement: "top",
    text: "",
    body: messages["home.tooltip.tax-fee"],
  });

  const [feeOtherTooltip] = useState({
    placement: "top",
    text: "",
    body: messages["home.tooltip.fee-other"],
  });

  return (
    <div className="d-flex flex-column position-relative">
      <Table className="table mb-0 flex-grow-1" style={{ tableLayout: "fixed", width: "100%" }}>
        <thead>
          <tr>
            <th className="text-muted text-extra-small mb-2" style={{ width: "5%" }}>#</th>
            <th className="text-muted text-extra-small mb-2" style={{ width: "35%" }}>
              <IntlMessages id="home.header.product" />
            </th>
            <th className="text-muted text-extra-small mb-2 text-center" style={{ width: "10%" }}>
              SL
            </th>
            <th className="text-center text-muted text-extra-small mb-2" style={{ width: "20%" }}>
              <IntlMessages id="home.header.price" />
            </th>
            <th className="text-center text-muted text-extra-small mb-2" style={{ width: "20%" }}>
              <IntlMessages id="home.header.total" />
            </th>
            <th
              className="text-right text-muted text-extra-small mb-2 cursor-pointer"
              onClick={removeOrders}
              style={{ width: "10%" }}
            >
              <IntlMessages id="home.header.delete" />
            </th>
          </tr>
        </thead>
        <tbody>
          {!orders.length ? (
            <tr>
              <td colSpan={6}>
                <span className="d-flex justify-content-center align-items-center p-3 text-muted empty-orders ">
                  <IntlMessages id="home.empty" />
                </span>
              </td>
            </tr>
          ) : (
            orders?.map((order, idx) => {
              return (
                <Fragment key={idx}>
                  <tr>
                    <td>{idx + 1}</td>
                    <td
                      className={
                        itemsChange?.length
                          ? "cursor-default"
                          : "cursor-body-menu"
                      }
                      onClick={
                        itemsChange?.length ? null : () => incrementItem(order)
                      }
                      style={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                      title={order?.name ? order.name : order?.product?.name}
                    >
                      {order?.name ? order.name : order?.product?.name}
                    </td>
                    <td
                      className={
                        itemsChange?.length
                          ? "text-center cursor-default align-middle"
                          : "text-center cursor-pointer align-middle"
                      }
                      style={{ verticalAlign: "middle" }}
                      onClick={
                        itemsChange?.length ? null : () => handleStartEdit(idx, order)
                      }
                    >
                      {editingIdx === idx ? (
                        <input
                          type="number"
                          className="form-control text-center p-1 font-weight-bold"
                          style={{
                            width: "60px",
                            height: "28px",
                            margin: "0 auto",
                            fontSize: "13px"
                          }}
                          value={tempCount}
                          onChange={(e) => setTempCount(e.target.value)}
                          onBlur={() => handleSaveCount(order)}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              handleSaveCount(order);
                            } else if (e.key === "Escape") {
                              setEditingIdx(null);
                            }
                          }}
                          autoFocus
                          onFocus={(e) => e.target.select()}
                          min="1"
                        />
                      ) : (
                        order.count
                      )}
                    </td>
                    <td className="text-center">
                      {AddCommaNumber(order.price)}
                    </td>
                    {/* {(discount_form &&
                                    discount_form.saved &&
                                    discount_form.value &&
                                    discount_form.type) ||
                                find_item_discount ? null : ( */}
                    <td className="text-center">
                      {AddCommaNumber(order.price * order.count)}
                    </td>
                    {/* )} */}

                    {/* {(discount_form &&
                                    discount_form.saved &&
                                    discount_form.value &&
                                    discount_form.type) ||
                                (order.discount &&
                                    order.discount.type &&
                                    order.discount.value) ? ( */}
                    {/* <td className='text-center'>
                                        {`${AddCommaNumber(
                                            getDiscountOrderValue(
                                                orders,
                                                discount_form,
                                                order
                                            )
                                        )}${getDiscountOrderType(
                                            discount_form,
                                            order
                                        )}`}
                                    </td> */}
                    {/* ) : null} */}
                    <td
                      className="text-right cursor-pointer"
                      onClick={() => onHandlerDeleteOrderPending(order, idx)}
                    >
                      <i className="simple-icon-trash" />
                    </td>
                  </tr>
                  {(order?.size === "" || order?.size === undefined) &&
                  (order?.color === "" || order?.color === undefined) &&
                  (order?.material === "" || order?.material === undefined) &&
                  (!order?.selectedAttributes ||
                    Object.keys(order.selectedAttributes).every((key) =>
                      ["size", "color", "material"].includes(key),
                    )) &&
                  (order.iceSelectedValue === "100" ||
                    order.iceSelectedValue === undefined) &&
                  (order.sugarSelectedValue === "100" ||
                    order.sugarSelectedValue === undefined) &&
                  !order.sizeSelectedId?.length &&
                  !order?.toppingSelectedId?.length &&
                  !order?.note ? null : (
                    <tr>
                      <td className="border-top-none"></td>
                      <td colSpan={5} className="pl-0">
                        {/* Hiển thị note (ví dụ: tên khuyến mại quà tặng) */}
                        {order?.note ? (
                          <Badge className="mr-1" color="success">
                            {order.note}
                          </Badge>
                        ) : null}
                        {/* Size badge fallback - only show when dynamic lookup is NOT available */}
                        {!order.sizeSelectedId?.length &&
                        order?.size !== "" &&
                        order?.size !== undefined &&
                        order?.size !== null ? (
                          <Badge className="mr-1" color="primary">
                            {order?.size}
                          </Badge>
                        ) : null}
                        {order?.color !== "" &&
                        order?.color !== undefined &&
                        order?.color !== null ? (
                          <Badge className="mr-1" color="primary">
                            {order?.color}
                          </Badge>
                        ) : null}
                        {order?.material !== "" &&
                        order?.material !== undefined &&
                        order?.material !== null ? (
                          <Badge className="mr-1" color="primary">
                            {order?.material}
                          </Badge>
                        ) : null}

                        {/* Dynamic Attributes Rendering */}
                        {order?.selectedAttributes &&
                          Object.entries(order.selectedAttributes).map(
                            ([key, attr], i) => {
                              // Skip already rendered attributes
                              if (["size", "color", "material"].includes(key))
                                return null;
                              return (
                                <Badge
                                  key={key}
                                  className="mr-1"
                                  color="primary"
                                >
                                  {attr.label || attr.value}
                                </Badge>
                              );
                            },
                          )}
                        {/* 1. Size (Dynamic Lookup) - Only if has selection */}
                        {(() => {
                          if (
                            !order.sizeSelectedId?.length ||
                            !order.sizeSettings
                          )
                            return null;
                          // Find selected size definition
                          const selectedSize = order.sizeSettings.find((s) =>
                            order.sizeSelectedId.some((id) => id == s.id),
                          );
                          // Hide if not found
                          if (!selectedSize) return null;

                          return (
                            <span>
                              <Badge className="mr-1" color="primary">
                                {selectedSize.name}
                              </Badge>
                            </span>
                          );
                        })()}

                        {/* Flavor */}
                        {(() => {
                          if (
                            !order.flavorSelectedId?.length ||
                            !order.flavorSettings
                          )
                            return null;
                          const selectedFlavor = order.flavorSettings.find(
                            (flavor) =>
                              order.flavorSelectedId.some(
                                (id) => id == flavor.id,
                              ),
                          );
                          if (!selectedFlavor) return null;

                          return (
                            <Badge className="mr-1" color="info">
                              Vị: {selectedFlavor.name}
                            </Badge>
                          );
                        })()}

                        {/* 2. Topping (Dynamic Lookup) */}
                        {(() => {
                          if (
                            !order.toppingSelectedId?.length ||
                            !order.toppingSettings
                          )
                            return null;
                          // Filter selected toppings
                          const selectedToppings = order.toppingSettings.filter(
                            (t) =>
                              order.toppingSelectedId.some((id) => id == t.id),
                          );

                          return selectedToppings.map((topping, idx) => (
                            <Badge color="success" className="mr-1" key={idx}>
                              {topping.name}
                            </Badge>
                          ));
                        })()}

                        {/* 3. Ice */}
                        {order.iceSelectedValue === "100" ||
                        order.iceSelectedValue === undefined ? null : (
                          <Badge className="mr-1" color="warning">
                            <IntlMessages id="home.order.ice" />:{" "}
                            {order.iceSelectedValue}%
                          </Badge>
                        )}

                        {/* 4. Sugar */}
                        {order.sugarSelectedValue === "100" ||
                        order.sugarSelectedValue === undefined ? null : (
                          <Badge className="mr-1" color="info">
                            <IntlMessages id="home.order.sugar" />:{" "}
                            {order.sugarSelectedValue}%
                          </Badge>
                        )}

                        {/* 5. Tax rate badge */}
                        {(() => {
                          const itemTax = parseFloat(
                            order.tax_rate !== undefined
                              ? order.tax_rate
                              : order.product?.tax_rate || order.tax_fee?.value || 0,
                          );
                          if (itemTax > 0) {
                            return (
                              <Badge className="mr-1" color="secondary">
                                <IntlMessages id="discount.tax" />: {itemTax}%
                              </Badge>
                            );
                          }
                          return null;
                        })()}
                      </td>
                    </tr>
                  )}
                  {/* Upsell inline: size upgrade + topping suggestions */}
                  {!itemsChange?.length &&
                    (order.sizeSettings?.length > 0 ||
                      order.flavorSettings?.length > 0 ||
                      order.toppingSettings?.length > 0) && (
                      <tr>
                        <td className="border-top-none p-0 pl-4" colSpan={6}>
                          <UpsellInline
                            order={order}
                            onUpgradeSize={onUpgradeSize}
                            onAddTopping={onAddTopping}
                          />
                        </td>
                      </tr>
                    )}
                </Fragment>
              );
            })
          )}
          {/* {discount_form && discount_form.saved && discount_form.note ? (
            <tr>
              <td className="discount-note no-print" colSpan={5}>
                * <IntlMessages id="home.summary.discount" />:{" "}
                {getDiscountOrderNote(discount_form, "")}
              </td>
            </tr>
          ) : null}
          {tax_fee && tax_fee.saved && tax_fee.note ? (
            <tr>
              <td className="discount-note no-print" colSpan={5}>
                * <IntlMessages id="home.summary.tax" />:{" "}
                {getDiscountOrderNote(tax_fee, "")}
              </td>
            </tr>
          ) : null}
          {fee_other && fee_other.saved && fee_other.note ? (
            <tr>
              <td className="discount-note no-print" colSpan={5}>
                * <IntlMessages id="home.summary.fee-other" />:{" "}
                {getDiscountOrderNote(fee_other, "")}
              </td>
            </tr>
          ) : null} */}
          {/* Hiển thị quà tặng từ khuyến mại */}
          {promotion_result &&
          promotion_result.gifts &&
          promotion_result.gifts.length > 0 ? (
            <tr>
              <td
                colSpan={6}
                className="p-2"
                style={{ backgroundColor: "#f8f9fa" }}
              >
                <div className="d-flex align-items-center">
                  <i
                    className="iconsminds-gift-box text-success mr-2"
                    style={{ fontSize: "1.2rem" }}
                  />
                  <span className="text-success font-weight-bold">
                    <IntlMessages id="order.summary.gift" />:
                  </span>
                </div>
                <ul className="mb-0 pl-4 mt-1">
                  {promotion_result.gifts.map((gift, idx) => (
                    <li key={idx} className="text-success">
                      {gift.label || gift.name}{" "}
                      {gift.quantity > 1 ? `x${gift.quantity}` : ""}
                    </li>
                  ))}
                </ul>
              </td>
            </tr>
          ) : null}

          {suggestionData && (
            <tr>
              <td colSpan="6" className="p-0 pt-2" style={{ maxWidth: 0 }}>
                <SuggestionPanel
                  suggestions={suggestionData}
                  onAddProduct={onAddSuggestionProduct}
                />
              </td>
            </tr>
          )}

          <tr>
            <td colSpan="6" className="p-0 pt-3 pb-3">
              <table className="table table-borderless background-color-none mb-0">
                <tbody>
                  <tr>
                    <td colSpan="4" className="text-right p-1">
                      <IntlMessages id="home.summary.total" />:
                    </td>
                    <td colSpan="2" className="text-center text-bold p-1">
                      <strong>{AddCommaNumber(calTotalPrice(orders))}</strong>
                    </td>
                  </tr>
                  <tr>
                    <td colSpan="4" className="text-right p-1">
                      <IntlMessages id="home.summary.discount" />:
                      <TooltipItem item={discountTooltip} id={22} />
                    </td>
                    <td
                      colSpan="2"
                      className="text-center text-bold p-1 cursor-pointer"
                      onClick={() =>
                        handleToggleModalDiscountTaxFee("discount")
                      }
                      // onClick={
                      //     discount_form.saved
                      //         ? () =>
                      //               handleRemoveValueModal(
                      //                   'discount'
                      //               )
                      //         : handleToggleModalDiscountTaxFee
                      // }
                    >
                      {discount_form &&
                      discount_form.saved &&
                      discount_form.value &&
                      discount_form.type ? (
                        AddCommaNumber(total_discount_price)
                      ) : (
                        <i className="simple-icon-plus text-primary" />
                      )}
                    </td>
                  </tr>
                  {discount_form &&
                    discount_form.saved &&
                    discount_form.note &&
                    !discount_form.isManual && (
                      <tr>
                        <td
                          colSpan="6"
                          className="text-right p-0 pr-2"
                          style={{
                            fontSize: "10px",
                            color: "#888",
                            lineHeight: "14px",
                          }}
                        >
                          <i className="simple-icon-tag mr-1" />
                          {discount_form.note}
                        </td>
                      </tr>
                    )}
                  <tr>
                    <td colSpan="4" className="text-right p-1">
                      <IntlMessages id="home.summary.tax" />:
                      <TooltipItem item={taxFeeTooltip} id={23} />
                    </td>
                    <td
                      colSpan="2"
                      className="text-center text-bold p-1 cursor-pointer"
                      onClick={() => handleToggleModalDiscountTaxFee("tax")}
                      // onClick={
                      //     tax_fee.saved
                      //         ? () =>
                      //               handleRemoveValueModal(
                      //                   'tax_fee'
                      //               )
                      //         : handleToggleModalDiscountTaxFee
                      // }
                    >
                      {(tax_fee &&
                      tax_fee.saved &&
                      tax_fee.value &&
                      tax_fee.type) || total_taxfee_price > 0 ? (
                        AddCommaNumber(total_taxfee_price)
                      ) : (
                        <i className="simple-icon-plus text-primary" />
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td colSpan="4" className="text-right p-1">
                      {hasFeeOther ? (
                        feeOtherLabel
                      ) : (
                        <IntlMessages id="home.summary.fee-other" />
                      )}:
                      <TooltipItem item={feeOtherTooltip} id={24} />
                    </td>
                    <td
                      colSpan="2"
                      className="text-center text-bold p-1 cursor-pointer"
                      onClick={() => handleToggleModalDiscountTaxFee("fee")}
                      // onClick={
                      //     fee_other.saved
                      //         ? () =>
                      //               handleRemoveValueModal(
                      //                   'fee_other'
                      //               )
                      //         : handleToggleModalDiscountTaxFee
                      // }
                    >
                      {hasFeeOther ? (
                        AddCommaNumber(total_fee_other_price)
                      ) : (
                        <i className="simple-icon-plus text-primary" />
                      )}
                    </td>
                  </tr>
                  {/* Phí ship */}
                  {shipping_fee > 0 && (
                    <tr>
                      <td colSpan="4" className="text-right p-1">
                        <span className="text-primary">
                          <i className="iconsminds-scooter mr-1" />
                          <IntlMessages id="home.summary.shipping" />:
                        </span>
                      </td>
                      <td
                        colSpan="2"
                        className="text-center text-bold p-1 text-primary"
                      >
                        {is_calculating_fee ? (
                          <IntlMessages id="home.btn.calculating" />
                        ) : (
                          AddCommaNumber(shipping_fee)
                        )}
                      </td>
                    </tr>
                  )}
                  {(discount_form &&
                    discount_form.saved &&
                    discount_form.value &&
                    discount_form.type) ||
                  (tax_fee && tax_fee.saved && tax_fee.value && tax_fee.type) ||
                  (fee_other && fee_other.saved && fee_other.value) ||
                  shipping_fee > 0 ||
                  find_item_discount ? (
                    <tr>
                      <td colSpan="4" className="text-right p-1 pt-3">
                        <IntlMessages id="home.summary.payment-total" />:
                      </td>
                      <td
                        colSpan="3"
                        className="text-center text-bold p-1 pt-3"
                      >
                        <strong>{AddCommaNumber(totalPayment)}</strong>
                      </td>
                    </tr>
                  ) : null}
                </tbody>
              </table>
            </td>
          </tr>
          <tr>
            <td colSpan="6" className="py-3">
              <Row className="d-flex flex-wrap justify-content-around align-items-center">
                {cashs.map((cash, idx) => {
                  return (
                    <Colxx
                      xxs="4"
                      sm="3"
                      key={idx}
                      className={
                        cashFill(cash.cash)
                          ? "cash-pay mr-1 px-2 py-1 bg-primary border border-primary mb-1 text-center cursor-body-menu"
                          : "cash-pay mr-1 px-2 py-1 border border-primary mb-1 text-center cursor-body-menu"
                      }
                      onClick={(e) => {
                        totalPay(e, cash.cash);
                      }}
                    >
                      {AddCommaNumber(cash.cash)}
                      <span
                        className={
                          cashFill(cash.cash) ? "text-white d-flex" : "d-none"
                        }
                      >
                        {cash.quantity}
                      </span>
                      <span
                        className={
                          cashFill(cash.cash)
                            ? "text-white d-flex dash-icon cursor-pointer"
                            : "d-none"
                        }
                        onClick={(e) => {
                          decrementCount(e, cash);
                        }}
                      >
                        <i className="simple-icon-minus" />
                      </span>
                    </Colxx>
                  );
                })}
              </Row>
            </td>
          </tr>
          {cashsPay?.length > 0 || isCustomPay ? (
            <tr>
              <td colSpan="6" className="p-0 pt-3 pb-3 text-right">
                <table className="table table-borderless background-color-none mb-0">
                  <tbody>
                    <>
                      <tr>
                        <td colSpan="4" className="text-right p-1 align-middle">
                          <IntlMessages id="home.summary.customer-pay" />:
                        </td>
                        <td colSpan="2" className="text-center text-bold p-1">
                          <Input
                            type="text"
                            name="customer_pay_input"
                            id="customer_pay_input"
                            className="form-control text-center font-weight-bold d-inline-block"
                            style={{
                              maxWidth: "150px",
                              height: "32px",
                              fontSize: "14px",
                              padding: "2px 8px",
                              borderColor: isCustomPay ? "#007bff" : "#ced4da",
                            }}
                            value={
                              isCustomPay
                                ? (customCustomerPayRaw !== "" && customCustomerPayRaw !== undefined
                                    ? AddCommaNumber(customCustomerPay)
                                    : "")
                                : (customerPayTotal > 0 ? AddCommaNumber(customerPayTotal) : "")
                            }
                            onChange={(e) => {
                              const raw = e.target.value.replace(/\D/g, "");
                              const numeric = raw ? parseInt(raw, 10) : 0;
                              onChangeCustomerPay(numeric, raw);
                            }}
                            onFocus={(e) => e.target.select()}
                            placeholder="0"
                            autoComplete="off"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td colSpan="4" className="text-right p-1 align-middle">
                          {isMissingAmount ? (
                            <>
                              <span className="text-danger font-weight-bold">
                                <IntlMessages id="home.summary.missing" />:{" "}
                              </span>
                              <TooltipItem
                                item={missingAmountTooltip}
                                id={20}
                              />
                            </>
                          ) : (
                            <span className="text-success font-weight-bold">
                              <IntlMessages id="home.summary.refund" />:{" "}
                            </span>
                          )}
                        </td>
                        <td
                          colSpan={
                            discount_form &&
                            discount_form.saved &&
                            discount_form.value &&
                            discount_form.type
                              ? 3
                              : 2
                          }
                          className="text-center text-bold p-1 align-middle"
                        >
                          <strong className={isMissingAmount ? "text-danger" : "text-success"}>
                            {refundToCustomer}
                          </strong>
                        </td>
                      </tr>
                    </>
                  </tbody>
                </table>
              </td>
            </tr>
          ) : null}
        </tbody>
      </Table>
    </div>
  );
};

export default injectIntl(ListOrders);
